import React from 'react';
import SocialLogo from 'social-logos';

export const Social = (props) => {
   return <SocialLogo icon={props.iconName} />;
};
